import { useEffect } from 'react';

/**
 * Cookieless Umami tracker. Не се зарежда, ако няма website id
 * (локално dev или преди setup-umami.sh).
 */
const UmamiTracker: React.FC = () => {
  useEffect(() => {
    const websiteId = process.env.REACT_APP_UMAMI_WEBSITE_ID;
    if (!websiteId) {
      return;
    }
    if (document.querySelector('script[data-umami-masterbook]')) {
      return;
    }

    const script = document.createElement('script');
    script.defer = true;
    script.src = process.env.REACT_APP_UMAMI_SCRIPT_URL || '/mb.js';
    script.setAttribute('data-website-id', websiteId);
    script.setAttribute('data-domains', 'masterbook.nl,www.masterbook.nl');
    script.setAttribute('data-umami-masterbook', '1');
    document.head.appendChild(script);
  }, []);

  return null;
};

export default UmamiTracker;
